import { RichtextStoryblok } from '@qlevr/shared/schema';
import { removeBrandAndPageFromLink, replaceLanguageInHref } from '@qlevr/shared/utilities';
import { MarkTypes, renderRichText, richTextResolver, storyblokInit, StoryblokRichTextNode } from '@storyblok/js';

// Initialize Storyblok SDK
storyblokInit({
  accessToken: process.env['NEXT_PUBLIC_STORYBLOK_API_TOKEN'],
});

export function mapRichText(text?: RichtextStoryblok, locale?: string | null): string {
  if (!text) return '';

  try {
    const html = richTextResolver({
      resolvers: {
        [MarkTypes.LINK]: (node: StoryblokRichTextNode) => {
          let href = node.attrs?.['href'] ?? '';

          // Remove brand and "/page" segment
          href = removeBrandAndPageFromLink(href);

          // Replace existing locale with the passed locale (if provided)
          if (locale) {
            href = replaceLanguageInHref(href, locale);
          }

          return `<a href="${href}" target="${node.attrs?.['target']}">${node.children ?? node.text}</a>`;
        },
      },
    }).render(text as StoryblokRichTextNode);

    return html;
  } catch (error) {
    console.warn('Error rendering rich text:', error);
    return renderRichText(text) || '';
  }
}
